import { IconFont, pointer } from '@byecode/ui'
import styled from 'styled-components'

export const List = styled.div`
    max-width: 656px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;
`

export const Operator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
`

export const ListItem = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    gap: 16px;
`

export const Cell = styled.div`
    flex: 1;
`

export const Line = styled.div`
    width: 10px;
    height: 1px;
    background: var(--color-gray-400);
`

export const ErrorTag = styled.div`
    padding: 0 4px;
    margin: 2px -4px;
    height: 100%;
    display: inline-block;
    line-height: 22px;
    color: var(--color-red-500);
    background-color: var(--color-red-200);
    border-radius: 4px;
    font-size: 14px;
    overflow: hidden;
`
